export const outputShapeKey = Symbol.for("Pothos.outputShapeKey");
export const parentShapeKey = Symbol.for("Pothos.parentShapeKey");
export const abstractReturnShapeKey = Symbol.for("Pothos.abstractReturnShapeKey");
export const inputShapeKey = Symbol.for("Pothos.inputShapeKey");
export const inputFieldShapeKey = Symbol.for("Pothos.inputFieldShapeKey");
export const outputFieldShapeKey = Symbol.for("Pothos.outputFieldShapeKey");
export const typeBrandKey = Symbol.for("Pothos.typeBrandKey");
//# sourceMappingURL=type-params.js.map
